import { CheckedState } from "@radix-ui/react-checkbox";
import { Checkbox } from "../ui/checkbox";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface PropertyOptionsFormProps {
  formData: {
    available: boolean;
    featured: boolean;
    hiddenFromCalendar: boolean;
    sortOrder?: number;
  };
  handleInputChange: (field: string, value: CheckedState | number) => void;
  canEdit?: boolean;
}

const PropertyOptionsForm = ({
  formData,
  handleInputChange,
  canEdit = false,
}: PropertyOptionsFormProps) => (
  <div className="space-y-6">
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Checkbox
          id="available"
          checked={formData.available}
          onCheckedChange={(checked) => handleInputChange("available", checked)}
        />
        <label htmlFor="available" className="text-sm font-medium">
          Propiedad disponible
        </label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="hiddenFromCalendar"
          checked={formData.hiddenFromCalendar}
          onCheckedChange={(checked) => handleInputChange("hiddenFromCalendar", checked)}
        />
        <label htmlFor="hiddenFromCalendar" className="text-sm font-medium">
          Ocultar del calendario
        </label>
      </div>

      <div className="flex items-center space-x-2">
        <Checkbox
          id="featured"
          checked={formData.featured}
          disabled={!canEdit}
          onCheckedChange={(checked) => handleInputChange("featured", checked)}
        />
        <label htmlFor="featured" className="text-sm font-medium">
          Propiedad destacada
        </label>
      </div>
    </div>

    <div className="space-y-2">
      <Label htmlFor="sortOrder">Orden de visualización</Label>
      <Input
        id="sortOrder"
        type="number"
        min={1}
        value={formData.sortOrder ?? 999}
        onChange={(e) => handleInputChange("sortOrder", parseInt(e.target.value) || 999)}
        className="w-32"
      />
      <p className="text-sm text-muted-foreground">
        Número menor = aparece primero. Valor 1 = primera posición.
      </p>
    </div>
  </div>
);

export default PropertyOptionsForm;
